import { InferGetServerSidePropsType } from "next"
import useRouterStore from "stores/routerStore"
import clientPromise from "utils/backend/mongodb"
import enrichSubmitters from "utils/backend/enrichSubmitters"
import StandaloneAppPreview from "views/AppPreview/StandaloneAppPreview"

const AppItem = ({
  app,
  relatedApps,
  id,
  OGThumbnail,
  locale,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const push = useRouterStore((state) => state?.router?.push)

  if (app === null) push?.("/404")
  return (
    <StandaloneAppPreview
      id={id}
      appItem={app}
      relatedApps={relatedApps}
      OGThumbnail={OGThumbnail}
      serverLocale={locale}
    />
  )
}
export default AppItem
export const getServerSideProps = async ({ params, locale }: any) => {
  const id = parseInt(params.id[0])
  const client = await clientPromise
  const db = client.db(process.env.NEXT_PUBLIC_MONGODB_DB)
  let app: any = await db.collection("apps").find({ trackId: id }).toArray()
  if (app?.length) {
    app = await enrichSubmitters(app, db)
  }
  const relatedApps = await db
    .collection("apps")
    .aggregate([
      {
        $search: {
          text: {
            query:
              app?.[0]?.submitters?.[0]?.submitterDescription ||
              app?.[0]?.trackName ||
              "a",
            path: [
              "submitters.submitterDescription",
              "submitters.translatedDescription.text",
            ],
            fuzzy: {
              maxEdits: 2,
              maxExpansions: 1,
            },
          },
        },
      },
      {
        $addFields: {
          score: {
            $meta: "searchScore",
          },
        },
      },
      {
        $match: {
          score: { $gt: 5 },
        },
      },
    ])
    .limit(7)
    .sort({ score: -1 })
    .toArray()

  const enrichedRelatedApps = relatedApps?.length
    ? await enrichSubmitters(relatedApps, db)
    : relatedApps

  const dev = process.env.NODE_ENV !== "production"

  const server = dev ? "http://localhost:3000" : "https://www.appollow.net"

  const OGThumbnail = JSON.stringify(
    `${server}/api/og?appName=${encodeURIComponent(
      app?.[0]?.trackName || "",
    )}&appIcon=${encodeURIComponent(app?.[0]?.artworkUrl512 || "")}&appPrice=${
      app?.[0]?.price
    }&submittedPrice=${app?.[0]?.submitterPrice}&locale=${encodeURIComponent(
      locale || "en",
    )}`,
  )

  if (app?.length === 0) {
    try {
      const response = await fetch(`https://itunes.apple.com/lookup?id=${id}`)
      const appResponse = await response.json()
      app = Array.isArray(appResponse?.results) ? appResponse.results : []
    } catch {
      app = []
    }
  }

  return {
    props: {
      app: app?.length > 0 ? JSON.parse(JSON.stringify(app))?.[0] : null,
      relatedApps: enrichedRelatedApps
        ? JSON.parse(JSON.stringify(enrichedRelatedApps))
        : null,
      id: id,
      OGThumbnail,
      locale,
    },
  }
}

// export const getServerSideProps = async ({ params }: any) => {
//   const res = await fetch(`https://itunes.apple.com/lookup?id=${params.id}`)
//   const app = await res.json()

//   return {
//     props: {
//       app,
//     },
//   }
// }
